module.exports = __webpack_public_path__ + "img/5left-3b8376ef.png";